import A from '../../Link/Link';

interface BrandItemProps {
  href: string;
  as: string;
  onClick: (e) => void;
  hasImage: boolean;
  imageSrc?: string;
  name: string;
}

export const BrandItem = (props: BrandItemProps) => {
  const { href, as, onClick, hasImage, imageSrc, name } = props;

  return (
    <div className="brand-item">
      <A className="brand-item__content" href={href} as={as} onClick={onClick}>
        {hasImage && <img src={imageSrc} alt={name} />}
        <span className="brand-item__name">{name}</span>
      </A>
    </div>
  );
};
